// extracted by mini-css-extract-plugin
export default {"cls1":"FreeformQuestion-cls1_zZ1","cls2":"FreeformQuestion-cls2_rH5 FreeformQuestion-cls1_zZ1"};